import { BaseService } from './base-service';
import { ResponsableDTO, GetResponsableOptionsParamsDTO } from '@/core/dto/responsable';

class UserService extends BaseService<ResponsableDTO> {
	constructor(public readonly basePath: string = '/user') {
		super();
	}

	async listOptions(params: GetResponsableOptionsParamsDTO): Promise<ResponsableDTO[]> {
		const url = this.basePath + `/user-list/${params.organization_id}/${params.company_id}`;
		const { data } = await this.getInstance().get(url);
		return data;
	}
}

const Service = Object.freeze(new UserService());
export { Service };
